import { useEffect } from 'react';
export const useFocusOnFirstErrorField = (errors, orderedRefs, forceFocus, setForceFocus) => {
    useEffect(() => {
        if (forceFocus) {
            setForceFocus(false);
            if (!errors || Object.keys(errors).length === 0) {
                return;
            }
            for (const [fieldName, ref] of orderedRefs) {
                if (errors[fieldName]?.length > 0 && ref.current) {
                    setTimeout(() => {
                        if (fieldName.includes('description')) {
                            const editor = ref.current;
                            if (!editor) {
                                return;
                            }
                            editor.selection?.focus();
                            const container = editor?.container || editor?.editor || ref.current;
                            const domNode = container instanceof HTMLElement
                                ? container
                                : document.querySelector('.jodit-react-container');
                            domNode?.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                            });
                        }
                        else {
                            ref.current.focus();
                        }
                    }, 0);
                    break;
                }
            }
        }
    }, [forceFocus]);
};
